import CancelIcon from '@mui/icons-material/Cancel'
import {
  Autocomplete,
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material'
import { SimpleFilterApi } from '@promoboxx/use-filter/dist/useSimpleFilter'
import I18n from 'i18n-js'

import RetailerAccountBrandAutocomplete from '@src/components/shared/Filter/RetailerAccountBrandAutocomplete'
import FilterToolBar from '@src/components/shared/FilterToolbar'
import MenuItemWithCheckbox from '@src/lib/MenuItemWithCheckbox'

import { useAssetTags } from './useAssetTags'

export interface DownloadblesFilters {
  brands: string[]
  tags: string[]
  search: string
  brand: string
}

const Filters: React.FC<
  React.PropsWithChildren<{
    filterApi: SimpleFilterApi<DownloadblesFilters>
  }>
> = ({ filterApi }) => {
  const assetTags = useAssetTags()
  return (
    <FilterToolBar
      filterItems={[
        <RetailerAccountBrandAutocomplete
          value={filterApi.filterInfo.filter.brands}
          onChange={(value) =>
            filterApi.updateFilter({ brands: value.map((x) => String(x.id)) })
          }
          slotProps={{
            textField: {
              label: I18n.t('filters.selectBrands'),
              sx: {
                backgroundColor: (theme) => theme.palette.background.paper,
              },
            },
          }}
          showAll
        />,
        <Autocomplete
          multiple
          options={assetTags}
          value={filterApi.filterInfo.filter.tags}
          onChange={(event, value) => {
            filterApi.updateFilter({ tags: value })
          }}
          renderInput={(params) => {
            return (
              <TextField
                {...params}
                label={I18n.t('downloadables.filterByTags')}
                data-testid={'searchByTag'}
                sx={{
                  backgroundColor: (theme) => theme.palette.background.paper,
                }}
              />
            )
          }}
          renderOption={(props, option, state) => {
            return (
              <MenuItemWithCheckbox
                {...props}
                selected={state.selected}
                data-testid={`tagName: ${option}`}
              >
                {option}
              </MenuItemWithCheckbox>
            )
          }}
        />,
        <TextField
          value={filterApi.filterInfo.filter.search}
          onChange={(e) => filterApi.updateFilter({ search: e.target.value })}
          label={I18n.t('downloadables.search')}
          data-testid={'downloadablesSearchField'}
          fullWidth
          sx={{
            backgroundColor: (theme) => theme.palette.background.paper,
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {filterApi.filterInfo.filter.search.length > 0 && (
                  <IconButton
                    edge="end"
                    size="large"
                    onClick={() => filterApi.updateFilter({ search: '' })}
                  >
                    <CancelIcon />
                  </IconButton>
                )}
              </InputAdornment>
            ),
          }}
        />,
      ]}
      onClear={() => {
        filterApi.resetFilter()
        // HACK: usePreviouslySelected[Brands/Retailers] causes a clearing issue so we need to manually clear the brands filter
        filterApi.updateFilter({ brands: [] })
      }}
    />
  )
}

export default Filters
